export const USER_SETTINGS_PREFIX = 'pplx.local-user-settings.';
//# sourceMappingURL=constants.js.map